import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";

/**
 * Reusable index page for a top-level ecosystem section (Prodotti, Servizi,
 * Percorsi, Innovazione). Lists placeholder sub-sections as glass cards.
 */
export default function CategoryPage({
  eyebrow,
  title,
  description,
  items,
  testId,
  accent = "emerald",
}) {
  const accentRing =
    accent === "amber"
      ? "hover:border-amber-400/30"
      : "hover:border-emerald-400/30";

  return (
    <div className="px-5 sm:px-8 lg:px-12 py-20 max-w-6xl mx-auto">
      <PageHeader
        eyebrow={eyebrow}
        title={title}
        description={description}
        testId={testId ? `${testId}-header` : undefined}
      />

      <div
        data-testid={testId ? `${testId}-grid` : "category-grid"}
        className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
      >
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            data-testid={`category-item-${item.slug}`}
            className={`glass-card p-6 group transition-all duration-500 hover:-translate-y-1 ${accentRing}`}
          >
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="text-xl font-light text-white">{item.label}</div>
              <ArrowRight className="w-4 h-4 text-white/20 group-hover:text-white/70 group-hover:translate-x-1 transition-all shrink-0 mt-1.5" />
            </div>
            <div className="text-xs font-light text-white/45 leading-relaxed">
              {item.desc}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
